import clsx from "clsx";
import { FC } from "react";
import "swiper/scss";
import "swiper/scss/pagination";
import { Swiper } from "swiper/types";
import styles from "./SwiperPagination.module.scss";

interface SwiperPaginationProps {
  swiper?: Swiper;
  totalPages?: number;
  currentPage?: number;
}

export const SwiperPagination: FC<SwiperPaginationProps> = ({
  swiper,
  totalPages,
  currentPage = 1,
}) => {
  if (!swiper) return null;

  const handleGoToPage = (page: number) => {
    swiper.slideToLoop(page - 1);
  };

  return (
    <div className={styles["swiper-pagination"]}>
      <button
        className={clsx(styles["swiper-pagination-el"])}
        disabled={currentPage === 1}
        type="button"
        aria-label="Previous slide"
        onClick={() => {
          swiper.slidePrev();
        }}
      >
        &#8592;
      </button>

      <div className={styles["swiper-pagination-pages"]}>
        {Array.from({ length: totalPages }, (_, index) => {
          const pageNumber = index + 1;

          return (
            <button
              key={pageNumber}
              type="button"
              aria-label={`Go to slide ${pageNumber}`}
              aria-current={pageNumber === currentPage ? "page" : undefined}
              className={clsx(
                styles["swiper-pagination-el"],
                styles["swiper-pagination-page"],
                pageNumber === currentPage &&
                  styles["swiper-pagination-page--active"]
              )}
              onClick={() => handleGoToPage(pageNumber)}
            >
              {pageNumber}
            </button>
          );
        })}
      </div>

      <button
        className={clsx(styles["swiper-pagination-el"])}
        disabled={currentPage === totalPages}
        type="button"
        aria-label="Next slide"
        onClick={() => {
          swiper.slideNext();
        }}
      >
        &#8594;
      </button>
    </div>
  );
};

export default SwiperPagination;
